/**
 * Create a one-way SHA-256 hash of a string using the Web Crypto API
 * @param {string} value - The value to hash
 * @returns {Promise<string>} - The hexadecimal hash
 */
export async function hashValue(value) {
	if (!value) return '';
	
	const encoder = new TextEncoder();
	const data = encoder.encode(value);
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
	
	return hashHex;
}

/**
 * Create a one-way hash for a device ID to be used with third-party services
 * This ensures the device ID cannot be used to lookup user PII
 * @param {string} dvcid - The device ID to hash
 * @returns {Promise<string>} - The hashed device ID
 */
export async function hashDeviceId(dvcid) {
	return hashValue(dvcid);
}

export default {
	hashValue,
	hashDeviceId
};
